import React, { Component } from 'react';
import PropTypes from 'prop-types';
import getUrlParams from '../common/getUrlParams';
import AbsLink from '../../AbsLink';

class WrappedAbsLink extends Component {

  render() {
    const { href } = this.props;
    let { isActive } = this.props;
    const urlParam = typeof window !== 'undefined' && getUrlParams(window.location.href) || {};
    if (urlParam.r) { // unless the r query param exists
      isActive = urlParam.r === encodeURIComponent(href);
    }
    return (
      <AbsLink
        { ...this.props }
        isActive={ isActive }
      />
    );
  }
}

WrappedAbsLink.propTypes = {
  href: PropTypes.string,
  isActive: PropTypes.bool
};

export default WrappedAbsLink;
